import type {EntryPoint} from 'react-relay'
import {getRequest} from 'relay-runtime'

import {makeResource} from '../../../../../../../../utils/makeResource'

import {getCountsVariables, jobTestsTreeCountsQuery} from './JobTestsTree/JobTestsTree.queries'
import type {OverviewTabComponent} from './OverviewTab'

export const OverviewTabEntryPoint: EntryPoint<OverviewTabComponent, string> = {
  root: makeResource(
    'OverviewTab',
    () => import(/* webpackChunkName: "OverviewTab" */ './OverviewTab'),
  ),
  getPreloadProps: buildLocator => ({
    queries: {
      testCounts: {
        parameters: getRequest(jobTestsTreeCountsQuery),
        variables: getCountsVariables(buildLocator),
        options: {networkCacheConfig: {metadata: {essential: true}}},
      },
    },
  }),
}
